import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    FaArrowLeft,
    FaPaperPlane,
    FaClock,
    FaBell,
    FaUsers,
    FaLink,
    FaCalendarAlt,
    FaTag,
} from "react-icons/fa";
import getImageUrl from "../../utils/imageUrl";
import { getNotificationById } from "../services/adminApi";

import "../styles/NotificationDetails.css";

const NotificationDetails = () => {

    const { id } = useParams();

    const navigate = useNavigate();

    const [notification, setNotification] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        loadNotification();

    }, [id]);

    const loadNotification = async () => {

        try {

            const res = await getNotificationById(id);

            setNotification(res.data.notification);

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    };

    if (loading) {

        return <div className="notification-loading">Loading...</div>;

    }

    if (!notification) {

        return (
            <div className="notification-loading">

                Notification not found.

            </div>
        );

    }

    return (

        <div className="notification-details-page">

            <button
                className="back-btn"
                onClick={() => navigate(-1)}
            >

                <FaArrowLeft />

                Back

            </button>

            <div className="notification-header-card">

                <div>

                    <h1>{notification.title}</h1>

                    <p>{notification.message}</p>

                </div>

                <span
                    className={`status ${notification.status}`}
                >

                    {notification.status}

                </span>

            </div>

            <div className="details-grid">

                <div className="detail-card">

                    <h3>

                        <FaBell />

                        General Information

                    </h3>

                    <div className="detail-row">
                        <span>Type</span>
                        <strong>{notification.type}</strong>
                    </div>

                    <div className="detail-row">
                        <span>Priority</span>
                        <strong>{notification.priority}</strong>
                    </div>

                    <div className="detail-row">
                        <span>Audience</span>
                        <strong>{notification.audience}</strong>
                    </div>

                    <div className="detail-row">
                        <span>Status</span>
                        <strong>{notification.status}</strong>
                    </div>

                </div>

                <div className="detail-card">

                    <h3>

                        <FaUsers />

                        Delivery

                    </h3>

                    <div className="detail-row">
                        <span>Total Recipients</span>
                        <strong>
                            {notification.totalRecipients || 0}
                        </strong>
                    </div>

                    <div className="detail-row">
                        <span>Delivered</span>
                        <strong>
                            {notification.delivered || 0}
                        </strong>
                    </div>

                    <div className="detail-row">
                        <span>Opened</span>
                        <strong>
                            {notification.opened || 0}
                        </strong>
                    </div>

                    <div className="detail-row">
                        <span>Failed</span>
                        <strong>
                            {notification.failed || 0}
                        </strong>
                    </div>

                </div>

                <div className="detail-card">

                    <h3>

                        <FaLink />

                        Deep Link

                    </h3>

                    <div className="detail-row">
                        <span>Destination</span>
                        <strong>
                            {notification.deepLinkType || "-"}
                        </strong>
                    </div>

                    <div className="detail-row">
                        <span>Value</span>
                        <strong>
                            {notification.deepLinkValue || "-"}
                        </strong>
                    </div>

                </div>

                <div className="detail-card">

                    <h3>

                        <FaCalendarAlt />

                        Timeline

                    </h3>

                    <div className="detail-row">
                        <span>Created</span>
                        <strong>
                            {new Date(notification.createdAt).toLocaleString()}
                        </strong>
                    </div>

                    <div className="detail-row">
                        <span>Scheduled</span>
                        <strong>
                            {notification.scheduledAt
                                ? new Date(notification.scheduledAt).toLocaleString()
                                : "-"}
                        </strong>
                    </div>

                    <div className="detail-row">
                        <span>Sent</span>
                        <strong>
                            {notification.sentAt
                                ? new Date(notification.sentAt).toLocaleString()
                                : "-"}
                        </strong>
                    </div>

                </div>

            </div>

           {notification.image && (

    <div className="banner-card">

        <h2>
            <FaTag />
            Notification Banner
        </h2>

        <img
            src={getImageUrl(notification.image)}
            alt={notification.title}
            onError={(e) => {
                e.currentTarget.style.display = "none";
            }}
        />

    </div>

)}

            <div className="preview-card">

                <h2>Mobile Preview</h2>

                <div className="phone-preview">

                    <div className="mobile-notification">

                        <strong>HomeFoods</strong>

                        <h4>{notification.title}</h4>

                        <p>{notification.message}</p>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default NotificationDetails;